import React from 'react';

/**
 * ListLayout — 리스트 페이지 좌측 사이드바 + 콘텐츠 레이아웃.
 *
 * 시안: wireframes/concept-a-warm/list.html 의 .r-list-layout
 *
 * 모바일 (default ~ 1023px): sidebar 미노출, content 단일 컬럼
 * 데스크탑 (lg 1024px+): grid [248px_1fr] (v2), sidebar는 sticky 필터 카드
 *
 * 모바일에서 sidebar의 필터들은 기존 sticky FilterChipRow가 대체.
 */

export interface ListLayoutProps {
  /** lg+에서만 표시되는 좌측 필터 사이드바 (모바일에서는 sticky chip row 별도 사용) */
  sidebar: React.ReactNode;
  /** 모바일·데스크탑 모두 표시 */
  content: React.ReactNode;
  className?: string;
}

export const ListLayout: React.FC<ListLayoutProps> = ({
  sidebar,
  content,
  className = '',
}) => (
  <div
    className={`block lg:grid lg:grid-cols-[248px_1fr] lg:items-start lg:gap-6 lg:px-6 lg:pt-6 ${className}`}
  >
    {/* v2 목업 PC 02 `.side` — 248px 필터 카드 (2026-09-21 배치 4) */}
    <aside className="hidden lg:block lg:sticky lg:top-[84px] lg:self-start lg:rounded-ca-3xl lg:bg-frame lg:p-4 lg:shadow-ca-card lg:max-h-[calc(100vh-100px)] lg:overflow-y-auto">
      {sidebar}
    </aside>
    <div>{content}</div>
  </div>
);

export default ListLayout;
